<template>
  <div></div>
</template>
<script>
import { getAttributes } from '@/utils/http/modules/common.request.js'
const fontSizeKey = 'MY_FONTSIZE'
const fontSizePersonalKey = 'PERSONAL_FONTSIZE'
const fontSizeByTpid = 'TPID_FONTSIZE'
const whitePages = [
  '/memberPoints/index',
  '/memberPoints/task',
  '/memberPoints/mall',
  '/memberPoints/order',
  '/memberPoints/bill',
  '/memberPoints/sign',
  '/memberPoints/product/',
  '/memberPoints/success/',
]

export default {
  mounted() {
    const personalPages = ['/mine/index', '/myCouponList']
    if (whitePages.find(url => location.href.includes(url))) {
      this.getTopicFontSize()
    } else if (personalPages.some(page => location.href.includes(page))) {
      // 个人中心
      this.init({
        key: fontSizePersonalKey,
      })
    } else {
      this.init()
    }
    this.$bus.$on('CHANGE_FONT_SIZE', () => {
      if (location.href.includes('/mine/index')) {
        // 个人中心
        this.init({
          key: fontSizePersonalKey,
        })
      } else {
        this.init()
      }
    })
  },
  methods: {
    init({ count = 4, key = fontSizeKey } = {}) {
      let scale = Number(window.localStorage.getItem(key)) || 0
      this.$store.commit('UPDATE_FONTSIZE', scale)

      const fontSizes = [
        9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 22, 23, 24, 25, 28, 32,
      ]
      const fontStyleNormal = {}
      const fontStyleLargeToMiddle = {}

      fontSizes.forEach(size => {
        fontStyleNormal[`--set-font-size${size}`] = `calc(${size}px + ${
          count * scale
        }px)`
        fontStyleLargeToMiddle[
          `--set-font-size${size}-L2M`
        ] = `calc(${size}px + ${count * (scale === 2 ? 1 : scale)}px)`
      })

      const mergedFontStyle = { ...fontStyleNormal, ...fontStyleLargeToMiddle }

      Object.entries(mergedFontStyle).forEach(([k, v]) => {
        document.documentElement.style.setProperty(k, v)
      })
    },
    // 获取话题设置的字体大小
    async getTopicFontSize() {
      if (!window.zbvd.tpid) {
        window.localStorage.setItem(fontSizeByTpid, 0)
        this.init({ key: fontSizeByTpid })
        return
      }
      let scale = 0
      try {
        // 这接口有时候会返回报错，报错则用顶层window的配置
        const res = await getAttributes({
          tpId: window.zbvd.tpid,
          type: '1335',
        })
        console.log('fontsize-request', res)
        if (res.data.attrVal) {
          const attr = JSON.parse(res.data.attrVal)
          scale = attr.font_size == 0 ? 1 : attr.font_size == 2 ? 2 : 0
        }
      } catch (error) {
        const { font_size } =
          (window.top.zbvd && window.top.zbvd.commentAreaSetting) || {}
        console.log('fontsize-catch', error, font_size)
        scale = font_size == 0 ? 1 : font_size == 2 ? 2 : 0
      }
      window.localStorage.setItem(fontSizeByTpid, scale)
      this.init({ key: fontSizeByTpid })
    },
  },
}
</script>
<style lang="scss"></style>
